import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../AbstractElements";
import { Href, LinkUtilitiesTitle } from "../../../Constants/Constants";
import { LinkUtilitiesData, LinkUtilitiesSubTitle } from "../../../Data/UiKits/NavigateLinks";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Link } from "react-router-dom";

const LinkUtilities = () => {
  return (
    <Col xxl="3" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={LinkUtilitiesTitle} span={LinkUtilitiesSubTitle} />
        <CardBody>
          {LinkUtilitiesData.map((item, index) => (
            <P key={index}>
              <Link className={`link-${item} link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover" href="#!`} to={Href}>
                Link {item}
              </Link>
            </P>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default LinkUtilities;
